<template>
  <div class="Logout">
    <v-container>
      <v-layout row wrap>
        <div id="log">
          <h1 id="regHeading">Abmelden:</h1>
          <v-divider></v-divider>
          <v-flex>
            <v-btn color="blue" @click="logout"><span style="color: white">Abmelden</span></v-btn>
          </v-flex>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.commit("logout");
    }
  }
};
</script>

<style>
.Logout {
  text-align: center;
  opacity: 0.85;
  filter: alpha(opacity=85);
}

#log {
  background-color: white;
  width: 80%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px;
}

#regHeading {
  font-size: 250%;
}
</style>
